<template>
  <div>
    <loading-panel v-if="(!profile || loading) && !error"/>
    <card v-if="profile" class="card">
      <template slot="header">
        <div class="d-flex">
          <div class="mr-auto p-2"><h4 class="card-title">{{ $t('reportingProfiles.details.titleLbl') }}</h4></div>
          <edit-reporting-profile v-if="$auth.can({reporting_profile: 'update'}, 'permissions')" :form-details="profile"/>
          <base-button icon round type="danger" @click="deleteProfile()" class="text-nowrap zi_100"
                       v-if="$auth.can({reporting_profile: 'delete'}, 'permissions')">
            <span class="mdi mdi_icon mdi-24px mdi-close"/>
          </base-button>
          <!--          <create-account-deletion-btn-->
          <!--            v-if="account.status == 'ok' && $auth.can({account_delete: 'create'}, 'permissions')"-->
          <!--            :card-account="account.type === 'card'" :account-id="account.id"/>-->
          <!--          <account-cap-limit-btn :account-id="account.id" class="ml-2"/>-->
          <base-button type="neutral" size="sm" icon round class="ml-2 zi_100 no-print" @click="fullShow = !fullShow">
                      <span
                        :class="{'mdi_icon':true, 'mdi':true, 'mdi-18px':true, 'mdi-unfold-more-horizontal':!fullShow, 'mdi-unfold-less-horizontal':fullShow}"/>
          </base-button>
        </div>
      </template>
      <div class="row">
        <div class="col">
          <table class="striped_table w-100">
            <tbody>
            <tr>
              <td><label>{{ $t('reportingProfiles.details.label') }}</label></td>
              <td class="pl-2">{{ profile.label }}</td>
            </tr>
            <tr>
              <td><label>{{ $t('reportingProfiles.details.email') }}</label></td>
              <td class="pl-2"><a v-bind:href="'mailto:' + profile.email">{{ profile.email }}</a></td>
            </tr>
            <tr>
              <td><label>{{ $t('reportingProfiles.details.contact_name') }}</label></td>
              <td class="pl-2">{{ profile.contact_name }}</td>
            </tr>
            <tr>
              <td><label>{{ $t('reportingProfiles.details.contact_surname') }}</label></td>
              <td class="pl-2">{{ profile.contact_surname }}</td>
            </tr>
            <tr>
              <td><label>{{ $t('reportingProfiles.details.last_used_at') }}</label></td>
              <td class="pl-2" v-if="profile.last_used_at">{{ profile.last_used_at | time }}</td>
              <td class="pl-2" v-else></td>
            </tr>
            <tr>
              <td><label>{{ $t('reportingProfiles.details.additional_fields') }}</label></td>
              <td class="pl-2 pr-0">
                <table class="w-100 striped_table">
                  <tr v-for="(item, index) in profile.additional_fields" :key="index">
                    <td>{{ item.k }}</td>
                    <td>{{ item.v }}</td>
                    <td>
                      <el-tooltip :content="$t('reportingProfiles.additionalFieldsCustomization.removeHint')"
                                  effect="light"
                                  :open-delay="300" placement="top">
                        <base-button
                          class="remove btn-link m-0"
                          type="danger"
                          size="sm"
                          icon
                          @click.native="deleteAdditionalField(index)"
                        >
                          <i class="tim-icons icon-simple-remove"></i>
                        </base-button>
                      </el-tooltip>
                    </td>
                  </tr>
                </table>
                <form v-on:submit.prevent="addAdditionalField()">
                  <div class="row pt-1" v-if="$auth.can({reporting_profile: 'update'}, 'permissions')">
                    <div class="col pr-0">
                      <base-input v-model="newAdditionalFieldKey" size="xs"
                                  :placeholder="$t('reportingProfiles.additionalFieldsCustomization.keyPlaceholder')"/>
                    </div>
                    <div class="col pr-0">
                      <base-input v-model="newAdditionalFieldValue" size="sm"
                                  :placeholder="$t('reportingProfiles.additionalFieldsCustomization.valuePlaceholder')"/>
                    </div>
                    <div class="col-2 mw-100">
                      <base-button size="sm" icon round type="primary" native-type="submit"
                                   class="btn-fill">
                        <span class="mdi mdi_icon mdi-24px mdi-plus"/>
                      </base-button>
                    </div>
                  </div>
                </form>
              </td>
            </tr>

            </tbody>
            <tbody v-if="fullShow">
            <tr>
              <td><label>{{ $t('generic.id') }}</label></td>
              <td class="pl-2">{{ profile.id }}</td>
            </tr>
            <tr>
              <td><label>{{ $t('generic.created') }}</label></td>
              <td class="pl-2">{{ profile.created_at | time }}</td>
            </tr>
            <tr>
              <td><label>{{ $t('generic.updated') }}</label></td>
              <td class="pl-2">{{ profile.updated_at | time }}</td>
            </tr>
            <tr>
              <td><label>{{ $t('generic.createdBy') }}</label></td>
              <td class="pl-2">{{ profile.created_by }}</td>
            </tr>
            <tr>
              <td><label>{{ $t('generic.updatedBy') }}</label></td>
              <td class="pl-2">{{ profile.modified_by }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </card>
  </div>
</template>
<script>
import {mapActions, mapState} from "vuex";
import LoadingPanel from "@/components/LoadingPanel.vue";
import swal from "sweetalert2";
import EditReportingProfile from "./EditReportingProfile.vue"

export default {
  name: "ReportingProfileDetails",
  components: {
    LoadingPanel,
    EditReportingProfile
  },
  data() {
    return {
      fullShow: false,
      newAdditionalFieldKey: '',
      newAdditionalFieldValue: '',
    };
  },
  computed: {
    ...mapState({
      loading: state => state.reporting_profile.loading,
      error: state => state.reporting_profile.error,
      profile: state => state.reporting_profile.profile,
    }),
  },
  methods: {
    ...mapActions(['GetReportingProfile', 'UpdateReportingProfile']),
    deleteProfile() {
      swal({
        title: this.$t('reportingProfiles.delete.text'),
        text: this.profile.label,
        confirmButtonText: this.$t('reportingProfiles.delete.deleteBtnLabel'),
        cancelButtonText: this.$t('reportingProfiles.delete.cancelBtnLabel'),
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-secondary',
        type: 'question',
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('DeleteReportingProfile', this.profile).then(() => {
            if (!this.error) {
              this.$notify({
                type: 'success',
                message: this.$t('reportingProfiles.delete.deletedNotification', {label: this.profile.label}),
                icon: 'tim-icons icon-alert-circle-exc'
              })
              this.$router.push({
                name: 'reporting-profiles',
                params: {}
              }).catch(err => {
              })
            }
          })
        }
      });
    },
    deleteAdditionalField(index) {
      swal({
        title: this.$t('reportingProfiles.additionalFieldsCustomization.removeFieldLbl'),
        text: this.profile.additional_fields[index].k,
        confirmButtonText: this.$t('reportingProfiles.additionalFieldsCustomization.removeBtnLabel'),
        cancelButtonText: this.$t('reportingProfiles.additionalFieldsCustomization.cancelBtnLabel'),
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-secondary',
        type: 'question',
        showCancelButton: true
      }).then(result => {
        if (result.value) {
          let profile = this.profile
          profile.additional_fields.splice(index, 1)
          this.updateProfile(profile)
        }
      });
    },
    addAdditionalField() {
      let profile = this.profile
      if (profile.additional_fields === null) {
        profile.additional_fields = []
      }
      profile.additional_fields.push({K: this.newAdditionalFieldKey, V: this.newAdditionalFieldValue})
      this.updateProfile(profile)
    },
    updateProfile(profile) {
      this.$store.dispatch('UpdateReportingProfile', profile).then(() => {
        if (this.error !== null) {
          this.$notify({
            type: 'danger',
            message: `${this.error}`,
            icon: 'tim-icons icon-alert-circle-exc'
          })
        } else {
          this.$notify({
            type: 'success',
            message: `${this.$t('reportingProfiles.profileUpdated')}`,
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.newAdditionalFieldKey = ''
          this.newAdditionalFieldValue = ''
          this.$store.dispatch('GetReportingProfile', this.$route.params.id)
        }
      })
    },
  },
  mounted() {
    this.GetReportingProfile(this.$route.params.id)
  }
};
</script>
<style>
</style>
